// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"Breadcrumbs_Breadcrumbs__1P7q1"};